import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

async function callOpportunityAccess(action) {
  const response = await httpsCallable(
    functions,
    "talentLenzOpportunityInvitation",
  )({ action });
  return response?.data || null;
}

export const talentLenzOpportunityAccessApi = Object.freeze({
  getAccessContext: () => callOpportunityAccess("accessContext"),
  getProductLaunchContext: () => callOpportunityAccess("productContext"),
});
